import React, { useState } from 'react';

export const useHandleFormData = () => {
  const [formData, setFormData] = useState({
    orderTypes: [],
    userDetails: null
  });

  const setOrderType = selectedOrderTypes => {
    setFormData(({ orderTypes, ...rest }) => ({
      orderTypes: selectedOrderTypes,
      ...rest
    }));
  };

  const setUserDetails = userData => {
    setFormData(({ userDetails, ...rest }) => ({
      userDetails: userData,
      ...rest
    }));
  };

  return {
    ...formData,
    setOrderType,
    setUserDetails,
  };
};
